import { gql } from '__generated__';

export const ParticipantFieldEntryFieldsFragment = gql(`
  fragment ParticipantFieldEntryFields on ParticipantFieldEntry {
    id
    field {
      id
    }
    value
    choice_entries {
      id
      # We must select the full choice field for every choice entry because we can't select
      # disabled choices in any other way
      choice {
        id
        title
        position
        enabled
      }
    }
  }
`);

export const ParticipantFieldFieldsFragment = gql(`
  fragment ParticipantFieldFields on ParticipantField {
    id
    title
    description
    type
    scope
    required_promotions {
      id
    }
    enabled_choices {
      id
      title
      position
      enabled
    }
    required
    config
    has_external_validation
  }
`);

export const RegistrationFieldsFragment = gql(`
  fragment RegistrationFields on Registration {
    id
    qr_url
    qr_code
    sequence
    exchange_code
    exchange_amount
    locked
    complete
    ticket_complete
    upgrades_complete
    ticket_number
    start_time
    corral_name
    has_upgrades_available
    invited_email
    assigned
    required_attributes
    editable_attributes
    full_name
    first_name
    last_name
    date_of_birth
    gender
    nationality
    street
    house_number
    zip_code
    city
    extra_address_line
    country
    phone
    emergency_phone
    ticket_url
    claim_url
    claim_token
    is_reassignable
    is_unassignable
    status
    participant {
      id
      email
    }
    owner {
      id
      email
      full_name
    }
    owner_name
    ticket {
      id
      title
      business
      preregistration
      allow_individuals
      allow_create_team
      allow_join_team
      restrictions {
        id
        gender
        min_age
        max_age
      }
      units
      upcoming_time_slots {
        id
        start_date
        start_time
        title
        multi_date
        current_max_per_order
      }
    }
    time_slot {
      id
      start_date
      start_time
      title
      multi_date
      current_max_per_order
    }
    purchase {
      id
      unit_id
      batch_size
    }
    charity {
      id
      title
      logo_url
      description
    }
    default_charity {
      id
      title
      logo_url
      description
    }
    promotion {
      id
      title
    }
    team {
      id
      title
      captain {
        id
      }
    }
    group_members {
      id
      full_name
    }
    participant_fields {
      ...ParticipantFieldFields
    }
    participant_field_entries {
      ...ParticipantFieldEntryFields
    }
    upgrades {
      ...UpgradeFields
    }
    resale {
      id
      resellable
    }
    waitlist_paused
    waitlist_invite {
      id
      ticket {
        id
        title
        units
      }
      time_slot {
        id
        start_date
        start_time
        title
        multi_date
      }
      pending_invite {
        id
        expires_at
        amount
        total_amount
        fee
        upgrades {
          id
          product {
            id
            title
          }
          resale_amount
        }
      }
    }
    preregistration {
      id
      draw_result {
        id
        amount
        fee
        end_date
        ticket {
          id
          title
          upcoming_time_slots {
            id
            start_date
            start_time
            title
            multi_date
            is_sold_out
          }
        }
        promotion {
          id
          amount
          title
          standard
        }
        time_slot {
          id
          start_date
          start_time
          title
          multi_date
        }
      }
    }
    charity {
      id
      title
    }
    fundraising_campaign {
      id
      url
    }
  }
`);

export const UpgradeFieldsFragment = gql(`
  fragment UpgradeFields on Upgrade {
    id
    complete
    resale_amount
    product {
      id
      title
      type
      active_product_variants {
        id
        title
        is_sold_out
        position
      }
    }
    promotion {
      id
      title
    }
    product_variant {
      id
      title
      is_sold_out
      position
    }
    participant_fields {
      ...ParticipantFieldFields
    }
    participant_field_entries {
      ...ParticipantFieldEntryFields
    }
  }
`);

export default gql(`
  query GetRegistrationDetails($participant: ID!, $event: ID!, $token: String, $registration: ID!) {
    registrationSummary(participant: $participant, event: $event, token: $token) {
      id
      registration(id: $registration) {
        ...RegistrationFields
      }
    }
  }
`);
